import { Tag as BlueprintTag } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { InteractiveBadgeProps } from 'bones/design-system/components/badge/InteractiveBadge';
import {
  Icon,
  IconComponentType,
  IconWrapperProps,
} from 'bones/design-system/components/icons/Icon';

const ICON_SIZE_BY_STATIC_BADGE_SIZE: Record<
  StaticBadgeProps['size'],
  IconWrapperProps['size']
> = {
  lg: 'sm',
  md: 'xs',
  xs: 'xs',
};

export type StaticBadgeProps = Omit<
  InteractiveBadgeProps,
  'active' | 'onClick' | 'size' | 'variant'
> & {
  'data-testid'?: never;
  leftIcon?: IconComponentType;
  size: 'lg' | 'md' | 'xs';
  testId?: string;
  type: 'default' | 'info' | 'success' | 'warning' | 'error';
  variant: 'fill' | 'muted' | 'ghost';
};

export const StaticBadge: React.VFC<StaticBadgeProps> = ({
  children,
  className,
  leftIcon,
  size,
  testId,
  type,
  variant,
  ...props
}) => (
  <BlueprintTag
    className={classNames(
      className,
      'vb-static-badge',
      `vb-static-badge-size--${size}`,
      `vb-static-badge-type--${type}`,
      `vb-static-badge-variant--${variant}`
    )}
    data-testid={testId}
    icon={
      leftIcon ? (
        <Icon
          IconComponent={leftIcon}
          size={ICON_SIZE_BY_STATIC_BADGE_SIZE[size]}
        />
      ) : undefined
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {children}
  </BlueprintTag>
);
